import * as runtime from '@/api/runtime'
import {
  BatchTrcContentDetailUpdateRequest,
  BatchTrcContentDetailUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcContentDetailUpdateCondition,
  BatchTrcContentDetailUpdateConditionFromJSON
} from '@/api/models/batch/BatchTrcContentDetailUpdateCondition'

/**
 * 帳票作成
 */
export class BatchTrcContentDetailUpdateApi extends runtime.BaseAPI {
  async update(request: BatchTrcContentDetailUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-content-detail-update`,
      BatchTrcContentDetailUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcContentDetailUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcContentDetailUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
